import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { UserProductCatalogDto } from '@api/*';
import { PublishStatusFilter, SortOption } from '@app/shared/interface/webshop.interface';

export const ProductCatalogActions = createActionGroup({
    source: 'Public-Product-Catalog',
    events: {
        'Get Product Catalog': props<{ userId?: string | null; productCatalogId?: number | null }>(),
        'Get Product Catalog Success': props<{ response: UserProductCatalogDto[] }>(),
        'Get Product Catalog Failure': props<{ error: any }>(),

        // SEARCH AND FILTERS
        'Filter Search': props<{ searchTerm: string }>(),
        'Filter Sort': props<{ sortOption: SortOption }>(),
        'Filter Catalogs': props<{ catalogId: number }>(),
        'Filter Product Groups': props<{ groupId: number }>(),
        'Filter Publish Status': props<{ publishStatus: PublishStatusFilter }>(),
        'Filter Price Min': props<{ priceMin: number }>(),
        'Filter Price Max': props<{ priceMax: number }>(),
        'Filter Clear': emptyProps(),
    },
});
